<template>
  <div class="container footer-steps">
    <div class="row">
      <div v-if="!!previousStep" class="col">
        <button class="btn btn-outline-secondary" @click="$emit('set-step', activeStep-1)">
          Wstecz
          <span>{{ previousStep.title }}</span>
        </button>
      </div>
      <div v-if="!!nextStep" class="col text-right" >
        <button class="btn btn-outline-secondary"  @click="$emit('set-step', activeStep+1)">
          Dalej
          <span>{{ nextStep.title }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    // Aktualny krok
    activeStep: { type: Number },
    // Lista kroków
    steps: { type: Array }  
  },
  computed: {
    previousStep(){
      return this.steps[this.activeStep-1];
    },
    nextStep(){
      return this.steps[this.activeStep+1];
    }
  }
}
</script>